export const articles = [
  {
    id: "1",
    title: "某顶流男星深夜密会神秘女子，酒店共处8小时引热议",
    slug: "top-star-secret-date",
    excerpt: "据知情人士透露，该男星近期正在拍摄一部大制作电影，却频繁被拍到与同一女性出入高档酒店，疑似新恋情曝光。",
    content: `<p>近日，有网友在社交媒体上晒出一组照片，显示某知名男星深夜与一名神秘女子现身北京某五星级酒店。据目击者称，两人一前一后进入酒店，直到次日清晨才分别离开，全程约8小时。</p>
<p>该男星近期事业正处于上升期，其主演的电影票房突破30亿，人气居高不下。此前他曾公开表示自己是单身，专注于事业。然而这组照片的曝光，让不少粉丝感到震惊和失望。</p>
<p>有业内人士分析，该神秘女子可能是圈内新人，两人疑似因合作结缘。目前双方团队均未对此事作出回应。</p>`,
    category: "明星八卦",
    categorySlug: "celebrity-gossip",
    image: "https://readdy.ai/api/search-image?query=Silhouette%20of%20a%20man%20and%20woman%20walking%20separately%20into%20a%20luxury%20hotel%20at%20night%2C%20paparazzi%20style%20photography%2C%20moody%20atmospheric%20lighting%2C%20dark%20tones%2C%20cinematic%20look%2C%20mysterious%20vibe%2C%20editorial%20photography%2C%20no%20visible%20faces%2C%20soft%20shadows%2C%20elegant%20composition&width=800&height=560&seq=article-1&orientation=landscape",
    date: "2026-06-28",
    views: 125800,
    author: "八卦小编",
    tags: ["顶流", "恋情", "酒店", "深夜密会"],
    featured: true
  },
  {
    id: "2",
    title: "网红主播偷税漏税被罚2.8亿，直播账号已被永久封禁",
    slug: "streamer-tax-evasion",
    excerpt: "税务部门通报某头部带货主播涉嫌偷逃税款，累计罚款高达2.8亿元，其所有社交平台账号均遭封禁处理。",
    content: `<p>国家税务总局今日发布通报，某知名网络主播因涉嫌偷逃税款被依法查处。经查，该主播在2024年至2025年期间，通过隐匿个人收入、虚构业务转换收入性质等方式，偷逃个人所得税共计1.2亿元。</p>
<p>税务机关依法对其追缴税款、加收滞纳金并处罚款，合计2.8亿元。目前该主播已缴清全部款项。与此同时，各大平台已对其账号进行永久封禁处理。</p>
<p>该事件再次引发公众对网红主播税务合规问题的关注。业内人士呼吁行业加强自律，建立更加规范的税务管理体系。</p>`,
    category: "网红揭秘",
    categorySlug: "influencer-expose",
    image: "https://readdy.ai/api/search-image?query=Dark%20silhouette%20of%20a%20person%20behind%20a%20glass%20wall%20with%20numbers%20and%20calculations%20reflected%2C%20dramatic%20lighting%2C%20corporate%20investigation%20theme%2C%20moody%20cinematic%20style%2C%20dark%20background%2C%20editorial%20photography%2C%20abstract%20financial%20concept&width=800&height=560&seq=article-2&orientation=landscape",
    date: "2026-06-27",
    views: 289300,
    author: "吃瓜前线",
    tags: ["偷税", "网红", "罚款", "封禁"],
    featured: true
  },
  {
    id: "3",
    title: "知名导演被多名女演员实名举报，涉及潜规则丑闻持续发酵",
    slug: "director-scandal",
    excerpt: "五位女演员联合发布声明，指控某知名导演在片场存在不当行为，事件在业内引起轩然大波。",
    content: `<p>一场席卷娱乐圈的风暴正在酝酿。今日上午，五位女演员通过律师联合发布声明，实名举报某知名导演在过往合作中存在胁迫、骚扰等不当行为。</p>
<p>声明中详细列举了多起事件的时间、地点及具体细节，并附有部分聊天记录和录音证据。消息一出，立即在社交媒体上引发热议，相关话题阅读量短时间内突破10亿。</p>
<p>该导演此前曾执导多部票房过亿的电影，在行业内具有极高声望。目前，多家合作方已宣布暂停与其合作，其新片上映计划也面临搁置。</p>`,
    category: "明星八卦",
    categorySlug: "celebrity-gossip",
    image: "https://readdy.ai/api/search-image?query=Abstract%20representation%20of%20a%20directors%20chair%20in%20shadows%20on%20a%20film%20set%2C%20dramatic%20single%20light%20source%2C%20empty%20chair%2C%20moody%20atmosphere%2C%20dark%20cinematic%20tones%2C%20editorial%20photography%2C%20high%20contrast%2C%20foreboding%20mood&width=800&height=560&seq=article-3&orientation=landscape",
    date: "2026-06-26",
    views: 456700,
    author: "八卦小编",
    tags: ["导演", "举报", "潜规则", "女演员"],
    featured: true
  },
  {
    id: "4",
    title: "某女星离婚内幕曝光：财产分割涉及数亿资产，男方疑似婚内出轨",
    slug: "divorce-scandal-billions",
    excerpt: "娱乐圈又一对模范夫妻分道扬镳，离婚协议细节曝光，财产分割方案令人咋舌。",
    content: `<p>娱乐圈的婚姻似乎总是难以长久。近日，某知名女星与富商丈夫的离婚案终于尘埃落定。据知情人士透露，此次离婚涉及的财产分割金额高达数亿元，其中包括多处豪宅、豪车以及公司股权。</p>
<p>更令人震惊的是，有证据显示男方在婚内与多名女性保持不正当关系，这也是导致婚姻破裂的直接原因。女方律师团队在庭上提供了确凿的聊天记录和照片证据。</p>
<p>该女星在社交媒体上发文表示"重获新生"，获得大量粉丝支持。而男方则通过律师发表声明，否认了部分指控，但表示尊重法院判决。</p>`,
    category: "明星八卦",
    categorySlug: "celebrity-gossip",
    image: "https://readdy.ai/api/search-image?query=Cracked%20wedding%20ring%20on%20dark%20marble%20surface%2C%20symbolic%20divorce%20concept%2C%20dramatic%20lighting%20from%20side%2C%20luxury%20aesthetic%2C%20editorial%20photography%2C%20elegant%20and%20somber%20mood%2C%20dark%20background%2C%20minimalist%20composition&width=800&height=560&seq=article-4&orientation=landscape",
    date: "2026-06-25",
    views: 198400,
    author: "吃瓜前线",
    tags: ["离婚", "出轨", "财产分割", "女星"],
    featured: false
  },
  {
    id: "5",
    title: "选秀节目黑幕大起底：投票系统被曝存在严重造假行为",
    slug: "talent-show-fraud",
    excerpt: "前工作人员实名爆料某热门选秀节目的投票造假内幕，节目组涉嫌操纵观众投票结果。",
    content: `<p>选秀节目的公平性再次遭受质疑。一位自称曾在该节目组工作两年的前员工，今日通过视频平台发布了一段长达40分钟的爆料视频，详细揭露了节目投票系统的造假手法。</p>
<p>据其描述，节目组通过后台技术手段，可在直播过程中实时调整选手票数，甚至提前设定好最终排名。某些人气选手因"不受控制"而被刻意打压，而"听话"的选手则获得力捧。</p>
<p>该视频发布后迅速登上热搜榜首，大量网友涌入节目官方微博评论区要求解释。目前节目组尚未作出回应，但据悉相关监管部门已经介入调查。</p>`,
    category: "社会热点",
    categorySlug: "society",
    image: "https://readdy.ai/api/search-image?query=Abstract%20stage%20with%20spotlight%20casting%20shadows%20of%20puppet%20strings%2C%20dark%20theatrical%20atmosphere%2C%20manipulation%20concept%2C%20moody%20cinematic%20lighting%2C%20editorial%20photography%2C%20dark%20background%2C%20dramatic%20composition&width=800&height=560&seq=article-5&orientation=landscape",
    date: "2026-06-24",
    views: 345600,
    author: "八卦小编",
    tags: ["选秀", "黑幕", "投票造假", "爆料"],
    featured: true
  },
  {
    id: "6",
    title: "知名品牌代言人翻车：被曝使用竞品，品牌方紧急解约索赔",
    slug: "brand-ambassador-scandal",
    excerpt: "某一线艺人被拍到日常使用竞品产品，违反代言合约，品牌方连夜发函解约并索赔巨额违约金。",
    content: `<p>代言人使用竞品，这在娱乐圈可谓是大忌。近日，某一线艺人就被网友扒出在私人行程中使用了竞品品牌的产品，照片在网络上迅速传播。</p>
<p>该艺人与品牌签订的是独家代言合约，合约明确规定不得在任何场合使用或展示竞品。品牌方得知消息后，连夜发出解约函，并要求赔偿违约金及商誉损失，合计金额可能超过5000万元。</p>
<p>艺人团队随后发表致歉声明，称是"助理疏忽所致"，但这一解释并未获得品牌方和公众的认可。此事也引发了业内关于艺人代言规范化的讨论。</p>`,
    category: "网红揭秘",
    categorySlug: "influencer-expose",
    image: "https://readdy.ai/api/search-image?query=Broken%20luxury%20product%20on%20dark%20surface%2C%20symbolic%20brand%20crisis%20concept%2C%20dramatic%20side%20lighting%2C%20editorial%20product%20photography%2C%20dark%20elegant%20background%2C%20high%20contrast%2C%20minimalist%20sophisticated%20aesthetic&width=800&height=560&seq=article-6&orientation=landscape",
    date: "2026-06-23",
    views: 167800,
    author: "吃瓜前线",
    tags: ["代言", "翻车", "解约", "违约金"],
    featured: false
  },
  {
    id: "7",
    title: "某流量小生学历造假风波升级，母校发声明否认其就读经历",
    slug: "fake-degree-scandal",
    excerpt: "娱乐圈学历造假再添一例，某当红小生声称的海外名校学历被校方公开否认。",
    content: `<p>学历造假在娱乐圈并不罕见，但被母校公开"打脸"的却不多。今日，某海外知名大学通过其官方社交媒体发布声明，明确表示某流量小生并非该校毕业生，其声称的学位信息"与事实不符"。</p>
<p>该艺人此前在多个场合声称自己毕业于该校艺术系，这一"学霸人设"为其赢得了不少粉丝的好感。然而随着校方声明的发布，这一人设彻底崩塌。</p>
<p>事件曝光后，多个品牌已暂停与该艺人的合作。其工作室发布道歉声明，承认"在宣传中存在夸大表述"，但强调艺人确实曾在该校进行短期进修。</p>`,
    category: "明星八卦",
    categorySlug: "celebrity-gossip",
    image: "https://readdy.ai/api/search-image?query=Torn%20diploma%20certificate%20on%20dark%20wooden%20desk%2C%20symbolic%20academic%20fraud%20concept%2C%20dramatic%20lighting%2C%20editorial%20photography%2C%20dark%20moody%20atmosphere%2C%20high%20contrast%2C%20minimalist%20composition&width=800&height=560&seq=article-7&orientation=landscape",
    date: "2026-06-22",
    views: 289100,
    author: "八卦小编",
    tags: ["学历造假", "流量", "翻车", "学霸人设"],
    featured: false
  },
  {
    id: "8",
    title: "网红餐厅后厨曝光：蟑螂乱爬食材过期，老板连夜跑路",
    slug: "restaurant-hygiene-scandal",
    excerpt: "拥有百万粉丝的网红餐厅被前员工曝光后厨卫生状况触目惊心，监管部门已介入调查。",
    content: `<p>美食博主们争相打卡的"网红餐厅"，后厨竟是这般景象。一段由前员工拍摄的视频在网络疯传，画面中清晰可见蟑螂在操作台上乱爬，部分食材已明显过期变质。</p>
<p>该餐厅以"高端食材""匠心制作"为卖点，人均消费超过500元，在社交媒体上拥有超过200万粉丝。然而视频中的后厨状况与其宣传的形象形成鲜明对比。</p>
<p>事件曝光后，市场监管部门迅速介入，对该餐厅进行了突击检查，责令其停业整顿。餐厅老板疑似连夜失联，目前警方已介入调查。</p>`,
    category: "社会热点",
    categorySlug: "society",
    image: "https://readdy.ai/api/search-image?query=Dark%20shadows%20inside%20a%20commercial%20kitchen%2C%20dim%20lighting%2C%20eerie%20atmosphere%2C%20abandoned%20feel%2C%20moody%20cinematic%20style%2C%20editorial%20photography%2C%20dark%20tones%2C%20unsettling%20vibe&width=800&height=560&seq=article-8&orientation=landscape",
    date: "2026-06-21",
    views: 412300,
    author: "吃瓜前线",
    tags: ["网红餐厅", "卫生", "曝光", "后厨"],
    featured: true
  },
  {
    id: "9",
    title: "某综艺节目录制现场发生冲突，嘉宾愤然离场画面被曝光",
    slug: "variety-show-fight",
    excerpt: "热门综艺节目录制时两位嘉宾因观点不合爆发激烈争吵，其中一人当场摔麦离场。",
    content: `<p>综艺节目为了制造话题，往往会设计一些冲突环节，但这次似乎是真的失控了。据现场观众爆料，在某热门综艺的最新一期录制中，两位嘉宾因对某话题看法完全相反，从激烈辩论演变为争吵。</p>
<p>现场气氛一度十分尴尬，其中一位嘉宾在争吵中情绪失控，当场摔掉麦克风愤然离场。节目组紧急停机进行调解，但该嘉宾最终未能返回继续录制。</p>
<p>该节目的忠实观众对此反应不一，有人认为是真实情绪流露，也有人怀疑是节目组为博眼球故意安排的"剧本"。节目组暂未对此事作出公开回应。</p>`,
    category: "明星八卦",
    categorySlug: "celebrity-gossip",
    image: "https://readdy.ai/api/search-image?query=Empty%20TV%20studio%20set%20with%20a%20single%20fallen%20microphone%20on%20the%20floor%2C%20dramatic%20spotlight%2C%20abandoned%20atmosphere%2C%20moody%20cinematic%20lighting%2C%20editorial%20photography%2C%20dark%20background%2C%20high%20contrast&width=800&height=560&seq=article-9&orientation=landscape",
    date: "2026-06-20",
    views: 198700,
    author: "八卦小编",
    tags: ["综艺", "冲突", "离场", "录制事故"],
    featured: false
  }
];

export const categories = [
  {
    name: "明星八卦",
    slug: "celebrity-gossip",
    icon: "ri-star-line",
    description: "娱乐圈明星最新动态、恋情曝光、离婚八卦等一手资讯",
    count: 5
  },
  {
    name: "网红揭秘",
    slug: "influencer-expose",
    icon: "ri-live-line",
    description: "网红主播、UP主、博主等网络红人的黑料揭秘与翻车现场",
    count: 2
  },
  {
    name: "社会热点",
    slug: "society",
    icon: "ri-fire-line",
    description: "社会热点事件的深度解析与独家爆料内容",
    count: 2
  },
  {
    name: "深度揭秘",
    slug: "deep-dive",
    icon: "ri-search-eye-line",
    description: "长篇深度调查报告，还原事件真相的多维度解析",
    count: 0
  },
  {
    name: "圈内爆料",
    slug: "insider-tips",
    icon: "ri-spy-line",
    description: "娱乐圈内部人士匿名爆料，独家消息一手掌握",
    count: 0
  },
  {
    name: "吃瓜合集",
    slug: "melon-collection",
    icon: "ri-emotion-line",
    description: "每周热门吃瓜事件盘点，一次看过瘾的综合合集",
    count: 0
  }
];

export const testimonials = [
  {
    id: "1",
    content: "51黑料网是我们团队每天必看的信息来源，独家爆料的速度和深度都远超同行，真正做到了快、准、狠。",
    author: "娱乐周刊编辑部",
    role: "权威媒体推荐",
    image: "https://readdy.ai/api/search-image?query=Abstract%20editorial%20office%20interior%20with%20warm%20lighting%2C%20magazine%20aesthetic%2C%20creative%20workspace%2C%20minimalist%20design%2C%20soft%20shadows%2C%20editorial%20photography%2C%20elegant%20composition%2C%20neutral%20tones&width=400&height=560&seq=testimonial-1&orientation=portrait"
  },
  {
    id: "2",
    content: "作为自媒体创作者，51黑料网为我提供了大量独家素材和创作灵感，是我内容创作的重要信息源。",
    author: "知名娱乐博主 @八卦达人",
    role: "内容创作者推荐",
    image: "https://readdy.ai/api/search-image?query=Creative%20content%20creator%20workspace%20with%20laptop%20and%20warm%20ambient%20lighting%2C%20modern%20home%20office%2C%20editorial%20aesthetic%2C%20minimalist%20design%2C%20soft%20shadows%2C%20warm%20neutral%20tones&width=400&height=560&seq=testimonial-2&orientation=portrait"
  },
  {
    id: "3",
    content: "黑料网的内容始终保持客观中立，不站队、不造谣、不传谣，用事实说话，这在当下的媒体环境中非常难得。",
    author: "传媒大学新闻系教授 王立明",
    role: "学术界高度评价",
    image: "https://readdy.ai/api/search-image?query=Academic%20library%20interior%20with%20bookshelves%20and%20warm%20reading%20light%2C%20scholarly%20atmosphere%2C%20editorial%20photography%2C%20minimalist%20design%2C%20soft%20lighting%2C%20elegant%20composition%2C%20neutral%20warm%20tones&width=400&height=560&seq=testimonial-3&orientation=portrait"
  }
];

export const navLinks = [
  { name: "首页", path: "/" },
  { name: "明星八卦", path: "/category/celebrity-gossip" },
  { name: "网红揭秘", path: "/category/influencer-expose" },
  { name: "社会热点", path: "/category/society" },
  { name: "关于我们", path: "/about" }
];
